import { Box } from "@mui/material";
import EquipmentField from "components/EquipmentField";
import { PageTitle } from "components/PageTitle";
import { GetData } from "contexts/DataContext";
import { getLocalStorageItem, isObjectEmpty } from "data/functions";

import React, { useEffect, useState } from "react";
import { CheckPin } from "./CheckPin";
import { AvatarField } from "./ProfileField";
import { ButtonField } from "./fields/ButtonFied";
import { CameraField } from "./fields/CameraField";
import { ChannelField } from "./fields/ChannelField";
import { DelayField } from "./fields/DelayField";
import { OrderField } from "./fields/OrderField";
import { RateField } from "./fields/RateField";
import { TypeField } from "./fields/TypeField";
import { ZoomField } from "./fields/ZoomField";

export function SettingsBody(props) {
  const { dataObj } = GetData();

  const [check, setCheck] = useState(undefined);

  useEffect(() => {
    if (dataObj?.pin || !isObjectEmpty(getLocalStorageItem("data_pin"))) {
      setCheck(false);
    } else {
      setCheck(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.open]);

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <PageTitle home={true} title="Настройки" />
        {check === false ? (
          <Box
            sx={{
              alignItems: "center",
              alignSelf: "center",
              display: "flex",
              height: "100%",
              maxWidth: "820px",
              position: "relative",
              width: "100%",
            }}
          >
            <CheckPin open={props?.open} setCheck={setCheck} />
          </Box>
        ) : (
          check && (
            <Box
              sx={{
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                gap: "0px",
                maxWidth: "820px",
                overflow: "auto",
                padding: "0.4rem",
                position: "relative",
                width: "100%",
              }}
            >
              <AvatarField />

              <TypeField />
              <CameraField />
              <EquipmentField />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "12px",
                  width: "100%",
                }}
              >
                <RateField />
                <ZoomField />
              </Box>
              <DelayField />
              <OrderField />
              <ChannelField />
              <ButtonField />
            </Box>
          )
        )}
      </Box>
    </React.Fragment>
  );
}
